import { Component } from '@nicolas-riciotti/light2';
import Lenis from '../../helpers/Lenis';
import getPosition from '../../helpers/getPosition';
import Tween from '../../helpers/Tween.js';
import isMobile from '../../helpers/isMobile';

export default class BlockTranscribe extends Component {
    created() {
        this.words = [];
        this.$words = [];
        this.activeIndex = -1;
    }

    attached() {
        this.$text = this.querySelector('[transcribe-text]');
        this.$audio = this.querySelector('[transcribe-audio]');

        const rawJson = this.getAttribute('data-json');

        if (rawJson) {
            try {
                this.words = JSON.parse(rawJson);

                console.log('WORDS', this.words);

                this.renderWords();
            } catch (error) {
                console.error('Invalid transcript JSON:', error);
            }
        }
    }

    renderWords() {
        if (!this.$text || !Array.isArray(this.words)) return;
        this.$text.innerHTML = '';
        this.$words = this.words.map((item, index) => {
            const span = document.createElement('span');
            span.textContent = item.word;
            span.dataset.index = index;
            span.dataset.start = item.start;
            span.dataset.end = item.end;
            span.classList.add('transcribe-word');
            this.$text.appendChild(span);
            if (index < this.words.length - 1) {
                this.$text.appendChild(document.createTextNode(' '));
            }
            return span;
        });
    }

    update() {
        if (!this.$audio || !this.$words.length) return;

        const currentTime = this.$audio.currentTime;

        const index = this.words.findIndex((item) => {
            return currentTime >= item.start && currentTime < item.end;
        });

        if (index === this.activeIndex) return;

        if (this.activeIndex !== -1) {
            this.$words[this.activeIndex]?.classList.remove('is-active');
        }

        if (index !== -1) {
            this.$words[index]?.classList.add('is-active');
        }

        this.activeIndex = index;
    }
}

customElements.define('block-transcribe', BlockTranscribe);